import { Signer } from "@ethersproject/abstract-signer";
import {  Provider as ProviderType, TransactionResponse } from "@ethersproject/providers";
import getSwapQuote from "../functions/getSwapQuote";
import { NetworkType, NETWORK_CONFIG_URL, Quote } from "../index";
import { ethers } from "ethers";
import axios from "axios";
import { getFeeTokenApproval, getSourceTokenApproval, setFeeTokenApproval, setSourceTokenApproval } from "../functions/getApproval";
import { getFeeAmount } from "../functions/getFee";
import { getTxStatus } from "../functions/getTxStatus";

export class RouterProtocol {
  public readonly apiKey: string
  public readonly sourceNetworkId: string
  public readonly provider: ProviderType
  private networkConfig: ({ [chainId: string]: NetworkType }|undefined);

  constructor (apiKey:string,sourceNetworkId:string,provider:ProviderType) {
      this.apiKey = apiKey;
      this.provider = provider;
      this.sourceNetworkId = sourceNetworkId;
  }

  public async initialize(){
    try{
     const networks:NetworkType[]=await axios.get(NETWORK_CONFIG_URL).then((res)=>{
       return res.data
     })
     let network_config: { [chainId: string]: NetworkType } = {}
    networks.forEach(network => {
        network_config = { ...network_config, [network.networkId]: network }
        return
    })
     this.networkConfig=network_config;
    } catch(err){
      throw err
    }
  }
  // to-be deprecated
  public async initailize(){
    try{
     const networks:NetworkType[]=await axios.get(NETWORK_CONFIG_URL).then((res)=>{
       return res.data
     })
     let network_config: { [chainId: string]: NetworkType } = {}
    networks.forEach(network => {
        network_config = { ...network_config, [network.networkId]: network }
        return
    })
     this.networkConfig=network_config;
    } catch(err){
      throw err
    }
  }
  /**
   * gets quote
   */

  public async getQuote(
    amount:string,
    destinationNetworkId:string,
    sourceTokenAddress:string,
    destinationTokenAddress:string,
    userAddress:string,
    feeTokenAddress:string,
    slippageTolerance:number
    ):Promise<Quote>{
      try {
        if(!this.networkConfig)
        throw "Not initialized!"
        const res=await getSwapQuote({
          expandedAmount:amount,
          sourceNetworkId:this.sourceNetworkId,
          destinationNetworkId,
          sourceTokenAddress,
          destinationTokenAddress,
          userAddress,
          feeTokenAddress,
          slippageTolerance,
          network_config:this.networkConfig,
          widgetId:this.apiKey
        })
      return res
    } catch(err){
      throw err;
    }
  }
  /**
   * swaps
   */
  public async swap(quote:Quote,signer:Signer,txGasLimit?:string) {
try{
  if(!this.networkConfig)
  throw "Not initialized!"
  if(!quote)
  throw "No Quote"
    // setting the gas price and limit
    const gasPrice = await this.provider.getGasPrice()
    
    const gasLimit = ethers.utils.hexlify(Number(txGasLimit?txGasLimit:1000000))

    const transaction:TransactionResponse=await signer.sendTransaction({...quote.txn.execution,gasPrice,gasLimit});
    await transaction.wait()
    return transaction;}
    catch(err){
      throw err;
    }
  }
  public async getSourceTokenAllowance(tokenAddress: string,
    destinationNetworkId: string,
    userAddress: string,
    ){
    try{
      if(!this.networkConfig)
      throw "Not initialized!"
      return await getSourceTokenApproval({
      tokenAddress,
      sourceNetworkId:this.sourceNetworkId,
      provider:this.provider,
      destinationNetworkId,
      userAddress,
      network_config:this.networkConfig
    })}catch(err){
      throw err;
    }
    }
  public async getFeeTokenAllowance(tokenAddress: string,
    destinationNetworkId: string,
    userAddress: string,
    ){
    try{
      if(!this.networkConfig)
      throw "Not initialized!"
      return await getFeeTokenApproval({
      tokenAddress,
      networkId:destinationNetworkId,
      provider:this.provider,
      userAddress,
            network_config:this.networkConfig

    })}catch(err){
      throw err;
    }
    }

  public async approveSourceToken(tokenAddress: string,
    userAddress: string,
    amount: string,
    destinationNetworkId: string,
    signer:Signer,
    txGasLimit?:number){
    try{
      if(!this.networkConfig)
      throw "Not initialized!"
      const transactionReq= await setSourceTokenApproval({
      tokenAddress,
      amount,
      destinationNetworkId,
      userAddress,
      sourceNetworkId:this.sourceNetworkId,
            network_config:this.networkConfig

    })
    // setting the gas price and limit
    const gasPrice = await this.provider.getGasPrice()

    const gasLimit = ethers.utils.hexlify(Number(txGasLimit?txGasLimit:1000000))
    const transaction:TransactionResponse=await signer.sendTransaction({...transactionReq,gasPrice,gasLimit});
    await transaction.wait()
    return transaction;}catch(err){
      throw err;
    }
  }
  public async approveFeeToken(tokenAddress: string,
    userAddress: string,
    amount: string,signer:Signer,
    txGasLimit?:number){
  try {
    if(!this.networkConfig)
    throw "Not initialized!"
    const transactionReq= await setFeeTokenApproval({
     tokenAddress,
     amount,
     userAddress,
     sourceNetworkId:this.sourceNetworkId,
           network_config:this.networkConfig

   })
   // setting the gas price and limit
   const gasPrice = await this.provider.getGasPrice()

   const gasLimit = ethers.utils.hexlify(Number(txGasLimit?txGasLimit:1000000))
   const transaction:TransactionResponse=await signer.sendTransaction({...transactionReq,gasPrice,gasLimit});
   await transaction.wait()
   return transaction;} catch(err){
    throw err;
  }
  }
  public async getBridgeFee(
    destinationNetworkId: string,
  ){
    try{
      if(!this.networkConfig)
      throw "Not initialized!"
      const fee = await getFeeAmount({
      sourceNetworkId:this.sourceNetworkId,
      destNetworkId:destinationNetworkId,
      sourceProvider:this.provider,
            network_config:this.networkConfig
})
    return fee} catch(err){
      throw err;
    }
  }
  public async getTransactionStatus(txHash:string){
    try{
      if(!this.networkConfig)
      throw "Not initialized!"
      const res=await getTxStatus(txHash,this.sourceNetworkId)
    return res} catch(err){
      throw err;
    }
  }
}


// whole test
// feeTokenName
// transaction status in midway
// transaction status endpoint